import { BrandResponse } from "./BrandResponse";

export class BrandData {

    private static readonly BrandingStorageKey: string = "BrandEnv";

    static getLogo(): string | null {
        let data = this.getBrandData();
        if (data === null) {
            return null;
        }
        return data.Logo;
    }

    static getLabel(): string | null {
        let data = this.getBrandData();
        if (data === null) {
            return null;
        }
        return data.Label;
    }

    static getLink(): string | null {
        let data = this.getBrandData();
        if (data === null) {
            return null;
        }
        return data.Link;
    }

    static getPrimaryColor(): string | null {
        let data = this.getBrandData();
        if (data === null) {
            return null;
        }
        return data.PrimaryColor;
    }

    static getSecondaryColor(): string | null {
        let data = this.getBrandData();
        if (data === null) {
            return null;
        }
        return data.SecondaryColor;
    }

    static getBarColor(): string | null {
        let data = this.getBrandData();
        if (data === null) {
            return null;
        }
        return data.BarColor;
    }

    static getEntityNumberLabel(): string | null {
        let data = this.getBrandData();
        if (data === null) {
            return null;
        }
        return data.EntityNumberLabel;
    }

    static isICLTenant(): boolean {
        let data = this.getBrandData();
        if (data === null) {
            return false;
        } else if (data.Tenant == 2495 || data.Tenant == 2672) {
            return true
        } else {
            return false
        }
    }

    static getBrandData() {
        let brandingStorageKey = localStorage.getItem(this.BrandingStorageKey);
        if (brandingStorageKey === null) {
            return null;
        }
        return JSON.parse(brandingStorageKey);
    }

    static setBrandData(brandData: BrandResponse): void {
        if (brandData !== null) {
            localStorage.setItem(this.BrandingStorageKey, JSON.stringify(brandData));
            document.documentElement.style.setProperty("--primary-color", brandData.PrimaryColor);
            document.documentElement.style.setProperty("--secondary-color", brandData.SecondaryColor);
            document.documentElement.style.setProperty("--bar-color", brandData.BarColor);
        }
    }

    static resetBrand(): void {
        localStorage.removeItem(this.BrandingStorageKey);
        document.documentElement.style.setProperty("--primary-color", '#06CEA8');
        document.documentElement.style.setProperty("--secondary-color", '#41d8b7');
        document.documentElement.style.setProperty("--bar-color", "#353435");
    }

}
